import type { LocationQuery } from 'vue-router'
import { parseDateRangeModeFromQuery, type DateRangeMode } from '~/utils/dateRangeMode'

// Store para controlar los modales de SearchInput
export const useSearchModalsStore = defineStore('searchModals', () => {
  const openDest = ref(false)
  const openCalendar = ref(false)
  /** Compartido entre instancias de SearchInput (hero desktop/móvil, header). */
  const dateRangeMode = ref<DateRangeMode>('')

  function setDateRangeMode(mode: DateRangeMode) {
    dateRangeMode.value = mode
  }

  function syncDateRangeModeFromQuery(query: LocationQuery) {
    dateRangeMode.value = parseDateRangeModeFromQuery(query)
  }

  function openDestinationModal() {
    openDest.value = true
  }

  function openCalendarModal() {
    openCalendar.value = true
  }

  function closeDestinationModal() {
    openDest.value = false
  }

  function closeCalendarModal() {
    openCalendar.value = false
  }

  return {
    openDest,
    openCalendar,
    dateRangeMode,
    setDateRangeMode,
    syncDateRangeModeFromQuery,
    openDestinationModal,
    openCalendarModal,
    closeDestinationModal,
    closeCalendarModal
  }
})
